import routes from '../../../route_names'
import { getDefaultInterval } from '@/helpers/filter'

const filterGuard = function(to, from, next) {
  if (to.meta.requireDateFilter && !to.query.from) {
    if (from && from.query.from) {
      to.query.from = from.query.from
      to.query.to = from.query.to
    } else {
      const dates = getDefaultInterval(30)
      to.query.from = dates.from.split('-').reverse().join('-')
      to.query.to = dates.to.split('-').reverse().join('-')
    }

    return next(to)
  }
  if (to.meta.requireIntervalFilter && !to.query.interval) {
    to.query.interval = 'MONTHLY'
    return next(to)
  }
  next()
}

export default {
  path: 'projects/:projectId/campaigns/:campaignId/insights',
  name: routes.INSIGHTS,
  component: () => import(/* webpackChunkName: "dashboard" */ './Insights.vue'),
  meta: {
    layout: 'dashboard/DashboardLayout',
    requiresAuth: true,
    requiredRole: 'ADMIN',
    defaultChild: routes.INSIGHTS_OVERVIEW
  },

  children: [
    {
      path: 'overview',
      name: routes.INSIGHTS_OVERVIEW,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './Overview.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true,
        requireAttributeFilter: true
      },
      beforeEnter: filterGuard
    },
    {
      path: 'metrics',
      name: routes.INSIGHTS_METRICS,
      component: () =>
        import(
          /* webpackChunkName: "dashboard" */ './metrics/MetricInsights.vue'
        ),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN',
        requireDateFilter: true,
        requireAttributeFilter: true,
        defaultChild: routes.INSIGHTS_METRICS_NPS
      },
      children: [
        {
          path: 'nps',
          name: routes.INSIGHTS_METRICS_NPS,
          component: () =>
            import(
              /* webpackChunkName: "dashboard" */ './metrics/MetricLayout.vue'
            ),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true,
            defaultChild: routes.INSIGHTS_METRICS_NPS_SUMMARY
          },
          children: [
            {
              path: 'summary',
              name: routes.INSIGHTS_METRICS_NPS_SUMMARY,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/SummaryView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true
              },
              beforeEnter: filterGuard
            },
            {
              path: 'drivers',
              name: routes.INSIGHTS_METRICS_NPS_DRIVERS,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/DriverInsightView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true
              },
              beforeEnter: filterGuard
            },
            {
              path: 'trends',
              name: routes.INSIGHTS_METRICS_NPS_TRENDS,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/MetricTrendsView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true,
                requireIntervalFilter: true
              },
              beforeEnter: filterGuard
            }
          ],
          props: () => ({
            tabSettings: {
              preselected: null,
              tabs: [
                {
                  id: routes.INSIGHTS_METRICS_NPS_SUMMARY,
                  label: 'Summary'
                },
                {
                  id: routes.INSIGHTS_METRICS_NPS_DRIVERS,
                  label: 'Drivers'
                },
                {
                  id: routes.INSIGHTS_METRICS_NPS_TRENDS,
                  label: 'Trends'
                }
              ]
            }
          })
        },
        {
          path: 'csat',
          name: routes.INSIGHTS_METRICS_CSAT,
          component: () =>
            import(/* webpackChunkName: "dashboard" */ './metrics/MetricLayout.vue'),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true,
            defaultChild: routes.INSIGHTS_METRICS_CSAT_SUMMARY
          },
          props: () => ({
            tabSettings: {
              preselected: null,
              tabs: [
                {
                  id: routes.INSIGHTS_METRICS_CSAT_SUMMARY,
                  label: 'Summary'
                },
                {
                  id: routes.INSIGHTS_METRICS_CSAT_DRIVERS,
                  label: 'Drivers'
                },
                {
                  id: routes.INSIGHTS_METRICS_CSAT_TRENDS,
                  label: 'Trends'
                }
              ]
            }
          }),
          children: [
            {
              path: 'summary',
              name: routes.INSIGHTS_METRICS_CSAT_SUMMARY,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/SummaryView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true
              },
              beforeEnter: filterGuard
            },
            {
              path: 'drivers',
              name: routes.INSIGHTS_METRICS_CSAT_DRIVERS,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/DriverInsightView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true
              },
              beforeEnter: filterGuard
            },
            {
              path: 'trends',
              name: routes.INSIGHTS_METRICS_CSAT_TRENDS,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/MetricTrendsView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true,
                requireIntervalFilter: true
              },
              beforeEnter: filterGuard
            }
          ]
        },
        {
          path: 'ces',
          name: routes.INSIGHTS_METRICS_CES,
          component: () =>
            import(/* webpackChunkName: "dashboard" */ './metrics/MetricLayout.vue'),
          meta: {
            layout: 'dashboard/DashboardLayout',
            requiresAuth: true,
            requiredRole: 'ADMIN',
            requireDateFilter: true,
            requireAttributeFilter: true,
            defaultChild: routes.INSIGHTS_METRICS_CES_SUMMARY
          },
          props: () => ({
            tabSettings: {
              preselected: null,
              tabs: [
                {
                  id: routes.INSIGHTS_METRICS_CES_SUMMARY,
                  label: 'Summary'
                },
                {
                  id: routes.INSIGHTS_METRICS_CES_DRIVERS,
                  label: 'Drivers'
                },
                {
                  id: routes.INSIGHTS_METRICS_CES_TRENDS,
                  label: 'Trends'
                }
              ]
            }
          }),
          children: [
            {
              path: 'summary',
              name: routes.INSIGHTS_METRICS_CES_SUMMARY,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/SummaryView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true
              },
              beforeEnter: filterGuard
            },
            {
              path: 'drivers',
              name: routes.INSIGHTS_METRICS_CES_DRIVERS,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/DriverInsightView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true
              },
              beforeEnter: filterGuard
            },
            {
              path: 'trends',
              name: routes.INSIGHTS_METRICS_CES_TRENDS,
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ './metrics/MetricTrendsView.vue'
                ),
              meta: {
                layout: 'dashboard/DashboardLayout',
                requiresAuth: true,
                requiredRole: 'ADMIN',
                requireDateFilter: true,
                requireIntervalFilter: true
              },
              beforeEnter: filterGuard
            }
          ]
        }
      ]
    },
    {
      path: 'responses',
      name: routes.INSIGHTS_RESPONSES,
      component: () =>
        import(/* webpackChunkName: "dashboard" */ './ResponseListView.vue'),
      meta: {
        layout: 'dashboard/DashboardLayout',
        requiresAuth: true,
        requiredRole: 'ADMIN'
      }
    }
  ]
}
